import HeaderBannerAd from "./HeaderBannerAd";

export default HeaderBannerAd;
